import 'Styles/layout/theme.scss';
import 'swiper/swiper-bundle.css';

// Global Files
import Image from '../components/image';
import Swiper from '../components/swiper';
import Overlay from '../components/overlay';
import Header from '../components/header';
import MobNav from '../components/mobile-nav';
import Accor from '../components/accor';
import Animation from '../components/animation';

// Shared Section Components
import Hero from '../components/hero';
import TabbedProductCarousel from '../components/tabbed-product-carousel';
import FeaturedPromoCards from '../components/featured-promo-cards';
import ActivityNavigation from '../components/activity-navigation';
import Testimonials from '../components/testimonials';
import UgcSlider from '../components/ugc-slider';
import Blogs from '../components/blogs';

// Global Vue Directory
import Cart from '../vue/cart/cart';
import MiniCart from '../vue/cart/mini-cart';
import GlobalDrawer from '../vue/drawer/index';
import Wishlist from '../vue/wishlist/wishlist';
import tabbedProductCardApp from '../vue/tabbed-product-card/index';

Image();
Swiper();
Overlay();
Header();
MobNav();
Accor();
Animation();
Cart();
MiniCart();
GlobalDrawer();
Wishlist();
Hero();
TabbedProductCarousel();
FeaturedPromoCards();
ActivityNavigation();
Testimonials();
UgcSlider();
Blogs();
tabbedProductCardApp();

window.header.init();
window.mobileNavigation.init()
